/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import {useSelector} from 'react-redux'
import {isEmpty} from 'react-redux-firebase'
import {Redirect, Route} from 'react-router-dom'
import {routes} from '../../utils/config'

const PublicRoute = ({component: Component, ...rest}) => {
  const auth = useSelector(state => state.firebase.auth)

  return (
    <Route
      {...rest}
      render={props => {
        return isEmpty(auth) ? (
          <Component {...props} />
        ) : (
          <Redirect to={{pathname: routes.roleSelector.url, state: {from: props.location}}} />
        )
      }}
    />
  )
}

export default PublicRoute
